import api from "./Api";

class PedidoService {
  GetPedido(payload) {
    return api.get("/v1/pedido/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedido(payload) {
    return api.post("/v1/pedido/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedido(payload) {
    return api.put("/v1/pedido/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedido(payload) {
    return api.delete("/v1/pedido/" + payload).then((response) => {
      return response.data;
    });
  }

  GetPedidoOData(payload) {
    return api.get("/OData/Pedido" + payload).then((response) => {
      return response.data;
    });
  }

  ImprimirPedido(payload) {
    return api
      .get("/v1/pedido/Imprimir/" + payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
    // return api.get("/v1/pedido/Imprimir/" + payload).then((response) => {
    //   return response;
    // });
  }
}

export default new PedidoService();
